export function lussUrl(id: number) {
  let i;
  let j;
  let c;
  let crc = 0;

  const poly = 0x07;
  const file = `${id}.mp3`;
  const base = '//g.delfi.lt/luss/';
  const hex = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];

  for (j = 0; j < file.length; j++) {
    c = file.charCodeAt(j);
    crc ^= c;
    for (i = 0; i < 8; i++) {
      if (crc & 0x80) crc = (crc << 1) ^ poly;
      else crc <<= 1;
    }
    crc &= 0xff;
  }

  return `${base + hex[crc >> 4] + hex[crc & 0xf]}/${file}`;
}
